"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileProcessResponse = void 0;
var FileProcessResponse;
(function (FileProcessResponse) {
    let handlerType;
    (function (handlerType) {
        handlerType["SELECT_CREATORS"] = "select_creators";
        handlerType["FEATURE_FLAGS"] = "feature_flags";
        handlerType["CHANNEL_LABELS"] = "channel_labels";
        handlerType["REPAIR_DEPLOYMENTS"] = "repair_deployments";
        handlerType["DEPLOYMENTS_FRAUD"] = "deployments_fraud";
        handlerType["SELECT_CREATORS_PRE_PROCESS"] = "select_creators_pre_process";
        handlerType["FEATURE_FLAGS_IMPORT_PRE_PROCESS"] = "feature_flags_import_pre_process";
        handlerType["CHANNEL_LABELS_IMPORT_PRE_PROCESS"] = "channel_labels_import_pre_process";
        handlerType["ADVERTISER_BLOCKLIST"] = "advertiser_blocklist";
        handlerType["AGENCY_CREATORS"] = "agency_creators";
        handlerType["AGENCY_CREATORS_PRE_PROCESS"] = "agency_creators_pre_process";
        handlerType["EXPERIMENT_APPLY_PRE_PROCESS"] = "experiment_apply_pre_process";
        handlerType["EXPERIMENT_REMOVE_PRE_PROCESS"] = "experiment_remove_pre_process";
        handlerType["EXPERIMENT_ROLLOUT_PRE_PROCESS"] = "experiment_rollout_pre_process";
    })(handlerType = FileProcessResponse.handlerType || (FileProcessResponse.handlerType = {}));
    let validationStatus;
    (function (validationStatus) {
        validationStatus["VALIDATING"] = "validating";
        validationStatus["VALID"] = "valid";
        validationStatus["INVALID"] = "invalid";
    })(validationStatus = FileProcessResponse.validationStatus || (FileProcessResponse.validationStatus = {}));
})(FileProcessResponse = exports.FileProcessResponse || (exports.FileProcessResponse = {}));
